import { render, staticRenderFns } from "./EnrollDialog.vue?vue&type=template&id=70b70020&scoped=true&"
import script from "./EnrollDialog.vue?vue&type=script&lang=js&"
export * from "./EnrollDialog.vue?vue&type=script&lang=js&"
import style0 from "./EnrollDialog.vue?vue&type=style&index=0&id=70b70020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b70020",
  null
  
)

export default component.exports